export default {
  GET_PUBLIC_SUBJECTS_REQUEST: "GET_PUBLIC_SUBJECTS_REQUEST",
  GET_PUBLIC_SUBJECTS_SUCCESS: "GET_PUBLIC_SUBJECTS_SUCCESS",
  GET_PUBLIC_SUBJECTS_FAIL: "GET_PUBLIC_SUBJECTS_FAIL",

  GET_PUBLIC_TEACHERS_REQUEST: "GET_PUBLIC_TEACHERS_REQUEST",
  GET_PUBLIC_TEACHERS_SUCCESS: "GET_PUBLIC_TEACHERS_SUCCESS",
  GET_PUBLIC_TEACHERS_FAIL: "GET_PUBLIC_TEACHERS_FAIL",

  GET_PUBLIC_TEACHER_REQUEST: "GET_PUBLIC_TEACHER_REQUEST",
  GET_PUBLIC_TEACHER_SUCCESS: "GET_PUBLIC_TEACHER_SUCCESS",
  GET_PUBLIC_TEACHER_FAIL: "GET_PUBLIC_TEACHER_FAIL",
  GET_PUBLIC_TEACHER_COURSES_REQUEST: "GET_PUBLIC_TEACHER_COURSES_REQUEST",
  GET_PUBLIC_TEACHER_COURSES_SUCCESS: "GET_PUBLIC_TEACHER_COURSES_SUCCESS",
  GET_PUBLIC_TEACHER_COURSES_FAIL: "GET_PUBLIC_TEACHER_COURSES_FAIL",

  //loading
  PUBLIC_LOADING: "PUBLIC_LOADING",
};
